import { FaSteam, FaXbox } from 'react-icons/fa6'
import { SiEpicgames } from 'react-icons/si'
import type { IconBaseProps } from 'react-icons'

export function SteamIcon(props: IconBaseProps) {
  return <FaSteam {...props} />
}

export function FortniteIcon(props: IconBaseProps) {
  return <SiEpicgames {...props} />
}

export function XboxIcon(props: IconBaseProps) {
  return <FaXbox {...props} />
}
